<div class="report-card">
  <div class="header">
    Sales Estimate
    <span class="sub-header">
      As of Today
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>
  <div class="bad-text"></div>

  <div style="display: flex;">
    <canvas id="chartjs-7" class="chartjs" width="200" height="600" style="max-width: 150px;"></canvas>

    <app-loading-swirly [isLoading]="salesLoading"></app-loading-swirly>

    @if (!salesLoading) {
      <div class="sidebar">
        <div class="big-header">
          {{ salesTotal | currency:'USD':'symbol':'0.0-2' }}
          <div class="small">
            Sales Subtotal
          </div>
        </div>
        @if (!companyWide) {
          <div class="big-header">
            {{ (salesTotal / salesGoal) | percent }}
            <div class="small">
              Towards Goal
            </div>
          </div>
        }
        <div class="thicker-horizontal-line"></div>
        <div class="big-header">
          <span [ngStyle]="{'color': backlogColor}">{{ backlogTotal | currency:'USD':'symbol':'0.0-2' }}</span>
          <div class="small">
            In Backlog
          </div>
        </div>
        <div class="big-header">
          <span [ngStyle]="{'color': completeAndUnpaidColor}">{{ completeAndUnpaidTotal | currency:'USD':'symbol':'0.0-2' }}</span>
          <div class="small">
            Complete & Unpaid
          </div>
        </div>
        <div class="big-header">
          <span [ngStyle]="{'color': completeAndPaidColor}">{{ completeAndPaidTotal | currency:'USD':'symbol':'0.0-2' }}</span>
          <div class="small">
            Complete & Paid
          </div>
        </div>
        <div class="big-header">
          <span [ngStyle]="{'color': commissionLostColor}">-{{ commissionLostTotal | currency:'USD':'symbol':'0.0-2' }}</span>
          <div class="small">
            Commission Lost Jobs
          </div>
        </div>
      </div>
    }
  </div>
